import axios from "axios";
import { BASE_URL } from "../config/apiConfig";

export default axios.create({
 //baseURL: "http://localhost:7001",
   baseURL: "https://be.lotusmart.com.pk/admin",
});
